(function() {

  const makeCanonical = {
    'acura': 'Acura', 'alfa romeo': 'Alfa Romeo', 'am general': 'AM General',
    'aston martin': 'Aston Martin', 'audi': 'Audi', 'bentley': 'Bentley',
    'bmw': 'BMW', 'buick': 'Buick', 'cadillac': 'Cadillac',
    'chevrolet': 'Chevrolet', 'chrysler': 'Chrysler', 'dodge': 'Dodge',
    'ferrari': 'Ferrari', 'fiat': 'Fiat', 'ford': 'Ford', 'gmc': 'GMC',
    'genesis': 'Genesis', 'honda': 'Honda', 'hyundai': 'Hyundai',
    'infiniti': 'Infiniti', 'jaguar': 'Jaguar', 'jeep': 'Jeep', 'kia': 'Kia',
    'land rover': 'Land Rover', 'lexus': 'Lexus', 'lincoln': 'Lincoln',
    'maserati': 'Maserati', 'mazda': 'Mazda', 'mercedes-benz': 'Mercedes‑Benz',
    'mini': 'MINI', 'mitsubishi': 'Mitsubishi', 'nissan': 'Nissan',
    'porsche': 'Porsche', 'ram': 'Ram', 'subaru': 'Subaru', 'tesla': 'Tesla',
    'toyota': 'Toyota', 'volkswagen': 'Volkswagen', 'volvo': 'Volvo'
  };

  /* simple alias map → canonical key */
  const makeAlias = {
  'ac': 'acura',

  'alfa': 'alfa romeo',
  'romeo': 'alfa romeo',
  'alfa‑romeo': 'alfa romeo',

  'amgeneral': 'am general',
  'am general': 'am general',
  'am-gen': 'am general',

  'aston': 'aston martin',
  'martin': 'aston martin',
  'aston‑martin': 'aston martin',

  'aud': 'audi',

  'bently': 'bentley',
  'bent': 'bentley',

  'bm': 'bmw',
  'beemer': 'bmw',
  'bimmer': 'bmw',
  'bavarianmotorworks': 'bmw',
  'bavarian motor works': 'bmw',

  'buik': 'buick',
  'buc': 'buick',

  'caddy': 'cadillac',
  'cad': 'cadillac',
  'cadi': 'cadillac',
  'cadilac': 'cadillac',

  'chevy': 'chevrolet',
  'chev': 'chevrolet',
  'cheverolet': 'chevrolet',
  'chebby': 'chevrolet',
  'gm‑chevy': 'chevrolet',

  'chry': 'chrysler',
  'chrys': 'chrysler',
  'crysler': 'chrysler',

  'daywoo': 'daewoo',

  'dai': 'daihatsu',
  'daih': 'daihatsu',
  'diahatsu': 'daihatsu',

  'dodg': 'dodge',
  'mopar': 'dodge',

  'eagl': 'eagle',

  'ferrari': 'ferrari',
  'ferari': 'ferrari',
  'ferrarri': 'ferrari',

  'fix‑it‑again‑tony': 'fiat',
  'f.i.a.t.': 'fiat',

  'fsk': 'fisker',

  'fmc': 'ford',
  'blue oval': 'ford',
  'fo': 'ford',

  'freight': 'freightliner',
  'freight‑liner': 'freightliner',

  'gen': 'genesis',

  'gm': 'gmc',
  'general motors truck': 'gmc',
  'g m c': 'gmc',

  'hond': 'honda',
  'hnda': 'honda',

  'hum': 'hummer',
  'humvee': 'hummer',
  'hmmwv': 'hummer',

  'hyun': 'hyundai',
  'hundai': 'hyundai',
  'hyndai': 'hyundai',

  'inf': 'infiniti',
  'infinity': 'infiniti',

  'izuzu': 'isuzu',
  'iszuzu': 'isuzu',
  'iszu': 'isuzu',

  'jag': 'jaguar',
  'jags': 'jaguar',

  'jp': 'jeep',
  'jeeps': 'jeep',

  'kia motors': 'kia',

  'lambo': 'lamborghini',
  'lambogini': 'lamborghini',

  'landrover': 'land rover',
  'land‑rover': 'land rover',
  'lr': 'land rover',
  'rover': 'land rover',

  'lex': 'lexus',
  'lexas': 'lexus',

  'linc': 'lincoln',
  'lincon': 'lincoln',

  'lot': 'lotus',

  'lucid motors': 'lucid',

  'mas': 'maserati',
  'maser': 'maserati',
  'mase': 'maserati',

  'mayback': 'maybach',
  'mb‑maybach': 'maybach',
  'mercedes‑maybach': 'maybach',

  'maz': 'mazda',
  'madza': 'mazda',
  'mazada': 'mazda',

  'mcl': 'mclaren',
  'maclaren': 'mclaren',
  'mc laren': 'mclaren',

  'mercedes': 'mercedes-benz',
  'mercedes benz': 'mercedes-benz',
  'benz': 'mercedes-benz',
  'merc': 'mercedes-benz',

  'mercu': 'mercury',

  'mini cooper': 'mini',

  'mitsu': 'mitsubishi',
  'mits': 'mitsubishi',
  'mitsubshi': 'mitsubishi',

  'niss': 'nissan',
  'nisan': 'nissan',

  'olds': 'oldsmobile',
  'oldsmob': 'oldsmobile',
  'oldmobile': 'oldsmobile',
  'olds mobile': 'oldsmobile',

  'panz': 'panoz',

  'ply': 'plymouth',
  'plym': 'plymouth',

  'pole‑star': 'polestar',
  'pole': 'polestar',

  'pont': 'pontiac',
  'pon': 'pontiac',
  'ponitac': 'pontiac',
  'pontac': 'pontiac',

  'porche': 'porsche',
  'porsch': 'porsche',
  'porshe': 'porsche',
  'porsh': 'porsche',

  'ramtruck': 'ram',
  'ram trucks': 'ram',
  'dodgeram': 'ram',

  'riv': 'rivian',

  'rr': 'rolls-royce',
  'rolls': 'rolls-royce',
  'rolls royce': 'rolls-royce',

  'sab': 'saab',

  'satrn': 'saturn',
  'sat': 'saturn',

  'sci': 'scion',

  'smartcar': 'smart',
  'smart car': 'smart',

  'ster': 'sterling',

  'sub': 'subaru',
  'subie': 'subaru',
  'scooby': 'subaru',

  'susuki': 'suzuki',
  'suz': 'suzuki',

  'tsla': 'tesla',
  'tesla motors': 'tesla',

  'toyo': 'toyota',
  'toy': 'toyota',
  'toyoya': 'toyota',
  'yota': 'toyota',

  'vw': 'volkswagen',
  'v‑dub': 'volkswagen',
  'vdub': 'volkswagen',
  'volkswagon': 'volkswagen',
  'volks wagen': 'volkswagen',

  'vo': 'volvo',
  'volv': 'volvo',

  'wrk': 'workhorse',
  'work horse': 'workhorse'
};

  const knownModels = {
  'acura': ['CL', 'ILX', 'Integra', 'Legend', 'MDX', 'NSX', 'RDX', 'RL', 'RLX', 'RSX', 'SLX', 'TL', 'TLX', 'TSX', 'Vigor', 'ZDX'],
  'alfa romeo': ['164', '4C', 'Giulia', 'GTV-6', 'Milano', 'Spider', 'Stelvio', 'Tonale'],
  'am general': ['Hummer'],
  'aston martin': ['DB11', 'DB7', 'DB9', 'DBS', 'Rapide', 'V12 Vanquish', 'V8 Vantage', 'Vantage', 'Virage'],
  'audi': ['A3', 'A4', 'A4 allroad', 'A5', 'A6', 'A6 allroad', 'A7', 'A8', 'allroad', 'Cabriolet', 'Coupe', 'e-tron', 'e-tron GT', 'Q3', 'Q4 e-tron', 'Q5', 'Q7', 'Q8', 'R8', 'RS 3', 'RS 4', 'RS 5', 'RS 6', 'RS 7', 'RS Q8', 'S3', 'S4', 'S5', 'S6', 'S7', 'S8', 'SQ5', 'SQ7', 'SQ8', 'TT', 'TTS'],
  'bentley': ['Arnage', 'Azure', 'Bentayga', 'Brooklands', 'Continental', 'Flying Spur', 'Mulsanne'],
  'bmw': ['1 Series', '2 Series', '3 Series', '4 Series', '5 Series', '6 Series', '7 Series', '8 Series', 'Alpina B6', 'Alpina B7', 'Alpina B8', 'Alpina XB7', 'i3', 'i4', 'i7', 'i8', 'iX', 'M2', 'M3', 'M4', 'M5', 'M6', 'M8', 'X1', 'X2', 'X3', 'X3 M', 'X4', 'X4 M', 'X5', 'X5 M', 'X6', 'X6 M', 'X7', 'Z3', 'Z4', 'Z8'],
  'buick': ['Allure', 'Cascada', 'Century', 'Enclave', 'Encore', 'Encore GX', 'Envision', 'Estate Wagon', 'LaCrosse', 'LeSabre', 'Lucerne', 'Park Avenue', 'Rainier', 'Reatta', 'Regal', 'Rendezvous', 'Riviera', 'Roadmaster', 'Skylark', 'Terraza', 'Verano'],
  'cadillac': ['Allante', 'ATS', 'ATS-V', 'Brougham', 'Catera', 'Celestiq', 'CT4', 'CT4-V', 'CT5', 'CT5-V', 'CT6', 'CT6-V', 'CTS', 'CTS-V', 'DeVille', 'DTS', 'Eldorado', 'Escalade', 'Escalade ESV', 'Escalade EXT', 'Fleetwood', 'LSE', 'Lyriq', 'Seville', 'SRX', 'STS', 'STS-V', 'XLR', 'XLR-V', 'XT4', 'XT5', 'XT6', 'XTS'],
  'chevrolet': ['Astro', 'Avalanche', 'Aveo', 'Beretta', 'Blazer', 'Blazer EV', 'Bolt EUV', 'Bolt EV', 'Camaro', 'Caprice', 'Captiva Sport', 'Cavalier', 'Celebrity', 'Chevelle', 'Chevy Van', 'Citation', 'City Express', 'Cobalt', 'Colorado', 'Corsica', 'Corvette', 'Cruze', 'Cruze Limited', 'El Camino', 'Equinox', 'Equinox EV', 'Express', 'G-Series', 'HHR', 'Impala', 'Impala Limited', 'K1500', 'K2500', 'K3500', 'Lumina', 'LUV', 'Malibu', 'Malibu Classic', 'Malibu Limited', 'Malibu Maxx', 'Metro', 'Monte Carlo', 'Monza', 'Nova', 'Optra', 'Orlando', 'Prizm', 'S-10', 'Silverado 1500', 'Silverado 1500 Classic', 'Silverado 1500 LD', 'Silverado 1500 LTD', 'Silverado 2500', 'Silverado 2500 HD', 'Silverado 2500 HD Classic', 'Silverado 3500', 'Silverado 3500 HD', 'Silverado 3500 HD Classic', 'Silverado EV', 'Sonic', 'Spark', 'Spectrum', 'Sprint', 'SS', 'SSR', 'Suburban', 'Tahoe', 'Tracker', 'Trailblazer', 'TrailBlazer EXT', 'Traverse', 'Trax', 'Uplander', 'Vega', 'Venture', 'Volt'],
  'chrysler': ['200', '300', '300M', 'Aspen', 'Cirrus', 'Concorde', 'Conquest', 'Cordoba', 'Crossfire', 'E Class', 'Executive', 'Fifth Avenue', 'Grand Voyager', 'Imperial', 'Laser', 'LeBaron', 'LHS', 'New Yorker', 'Pacifica', 'Prowler', 'PT Cruiser', 'Sebring', 'TC', 'Town & Country', 'Voyager'],
  'daewoo': ['Lanos', 'Leganza', 'Nubira'],
  'daihatsu': ['Charade', 'Rocky'],
  'dodge': ['Avenger', 'Caliber', 'Caravan', 'Challenger', 'Charger', 'Colt', 'Conquest', 'D150', 'D250', 'D350', 'Dakota', 'Dart', 'Daytona', 'Diplomat', 'Durango', 'Dynasty', 'Grand Caravan', 'Hornet', 'Intrepid', 'Journey', 'Lancer', 'Magnum', 'Mirada', 'Monaco', 'Neon', 'Nitro', 'Omni', 'Raider', 'Ram 1500 Van', 'Ram 2500 Van', 'Ram 3500 Van', 'Ram 50', 'Ramcharger', 'Rampage', 'Shadow', 'Spirit', 'Sprinter', 'SRT Viper', 'Stealth', 'Stratus', 'Viper', 'W150', 'W250', 'W350'],
  'eagle': ['Medallion', 'Premier', 'Summit', 'Talon', 'Vision'],
  'ferrari': ['360', '456M', '458 Italia', '488 GTB', '550', '575M', '599', '612 Scaglietti', '812 Superfast', 'California', 'Enzo', 'F12berlinetta', 'F430', 'F8', 'FF', 'GTC4Lusso', 'LaFerrari', 'Portofino', 'Roma', 'SF90 Stradale'],
  'fiat': ['124 Spider', '500', '500L', '500X', '500e'],
  'fisker': ['Karma', 'Ocean'],
  'ford': ['Aerostar', 'Aspire', 'Bronco', 'Bronco II', 'Bronco Sport', 'C-Max', 'Contour', 'Courier', 'Crown Victoria', 'E-150', 'E-250', 'E-350', 'E-Series Van', 'EcoSport', 'Edge', 'Escape', 'Escort', 'E-Transit', 'Excursion', 'Expedition', 'Explorer', 'Explorer Sport Trac', 'F-100', 'F-150', 'F-150 Heritage', 'F-150 Lightning', 'F-150 Raptor', 'F-250', 'F-250 Super Duty', 'F-350', 'F-350 Super Duty', 'F-450 Super Duty', 'Festiva', 'Fiesta', 'Five Hundred', 'Flex', 'Focus', 'Focus Electric', 'Freestar', 'Freestyle', 'Fusion', 'Fusion Energi', 'GT', 'LTD', 'Mach-E', 'Maverick', 'Mustang', 'Probe', 'Ranger', 'Taurus', 'Taurus X', 'Tempo', 'Thunderbird', 'Transit', 'Transit Connect', 'Transit Custom', 'Windstar', 'ZX2'],
  'freightliner': ['Sprinter'],
  'genesis': ['G70', 'G80', 'G90', 'GV60', 'GV70', 'GV80'],
  'geo': ['Metro', 'Prizm', 'Spectrum', 'Storm', 'Tracker'],
  'gmc': ['Acadia', 'C1500', 'C2500', 'C3500', 'Caballero', 'Canyon', 'Envoy', 'Envoy XL', 'Envoy XUV', 'G-Series', 'Hummer EV', 'Jimmy', 'K1500', 'K2500', 'K3500', 'Rally Wagon', 'S-15', 'Safari', 'Savana', 'Sierra 1500', 'Sierra 1500 Classic', 'Sierra 1500 HD', 'Sierra 1500 Limited', 'Sierra 2500', 'Sierra 2500 HD', 'Sierra 2500 HD Classic', 'Sierra 3500', 'Sierra 3500 HD', 'Sierra 3500 HD Classic', 'Sonoma', 'Suburban', 'Syclone', 'Terrain', 'Typhoon', 'Vandura', 'Yukon', 'Yukon XL'],
  'honda': ['Accord', 'Accord Crosstour', 'Civic', 'Civic del Sol', 'Clarity', 'CR-V', 'CR-Z', 'Crosstour', 'CRX', 'Element', 'EV Plus', 'Fit', 'HR-V', 'Insight', 'Odyssey', 'Passport', 'Pilot', 'Prelude', 'Prologue', 'Ridgeline', 'S2000'],
  'hummer': ['H1', 'H2', 'H3', 'H3T'],
  'hyundai': ['Accent', 'Azera', 'Elantra', 'Elantra GT', 'Elantra N', 'Entourage', 'Equus', 'Excel', 'Genesis', 'Genesis Coupe', 'Ioniq 5', 'Ioniq 6', 'Ioniq Electric', 'Ioniq Hybrid', 'Kona', 'Kona Electric', 'Kona N', 'Nexo', 'Palisade', 'Pony', 'Santa Cruz', 'Santa Fe', 'Santa Fe Sport', 'Santa Fe XL', 'Scoupe', 'Sonata', 'Sonata Hybrid', 'Stellar', 'Tiburon', 'Tucson', 'Veloster', 'Veloster N', 'Venue', 'Veracruz', 'XG300', 'XG350'],
  'infiniti': ['EX35', 'EX37', 'FX35', 'FX37', 'FX45', 'FX50', 'G20', 'G25', 'G35', 'G37', 'I30', 'I35', 'J30', 'JX35', 'M30', 'M35', 'M37', 'M45', 'M56', 'Q40', 'Q45', 'Q50', 'Q60', 'Q70', 'Q70L', 'QX30', 'QX4', 'QX50', 'QX55', 'QX56', 'QX60', 'QX70', 'QX80'],
  'isuzu': ['Amigo', 'Ascender', 'Axiom', 'Hombre', 'i-280', 'i-290', 'i-350', 'i-370', 'Impulse', 'Oasis', 'Pickup', 'Rodeo', 'Rodeo Sport', 'Stylus', 'Trooper', 'VehiCROSS'],
  'jaguar': ['E-Pace', 'F-Pace', 'F-Type', 'I-Pace', 'S-Type', 'Super V8', 'Vanden Plas', 'X-Type', 'XE', 'XF', 'XJ', 'XJ6', 'XJ8', 'XJ12', 'XJR', 'XJS', 'XK', 'XK8', 'XKR'],
  'jeep': ['Cherokee', 'CJ', 'Comanche', 'Commander', 'Compass', 'Gladiator', 'Grand Cherokee', 'Grand Cherokee L', 'Grand Wagoneer', 'Liberty', 'Patriot', 'Renegade', 'Scrambler', 'Wagoneer', 'Wrangler', 'Wrangler JK'],
  'kia': ['Amanti', 'Borrego', 'Cadenza', 'Carnival', 'Clarus', 'Credos', 'EV6', 'EV9', 'Forte', 'Forte Koup', 'Forte5', 'K5', 'K900', 'Magentis', 'Niro', 'Niro EV', 'Optima', 'Potentia', 'Rio', 'Rio5', 'Rondo', 'Sedona', 'Sephia', 'Seltos', 'Shuma', 'Sorento', 'Soul', 'Soul EV', 'Spectra', 'Spectra5', 'Sportage', 'Stinger', 'Telluride', 'Visto'],
  'lamborghini': ['Aventador', 'Countach', 'Diablo', 'Gallardo', 'Huracan', 'Murcielago', 'Urus'],
  'land rover': ['Defender', 'Discovery', 'Discovery Sport', 'Freelander', 'LR2', 'LR3', 'LR4', 'Range Rover', 'Range Rover Evoque', 'Range Rover Sport', 'Range Rover Velar'],
  'lexus': ['CT 200h', 'ES 250', 'ES 300', 'ES 300h', 'ES 330', 'ES 350', 'GS 200t', 'GS 300', 'GS 350', 'GS 400', 'GS 430', 'GS 450h', 'GS 460', 'GS F', 'GX 460', 'GX 470', 'HS 250h', 'IS 200t', 'IS 250', 'IS 300', 'IS 350', 'IS 500', 'IS F', 'LC 500', 'LC 500h', 'LFA', 'LM 350h', 'LS 400', 'LS 430', 'LS 460', 'LS 500', 'LS 500h', 'LS 600h L', 'LX 450', 'LX 470', 'LX 570', 'LX 600', 'NX 200t', 'NX 250', 'NX 300', 'NX 300h', 'NX 350', 'NX 350h', 'NX 450h+', 'RC 200t', 'RC 300', 'RC 350', 'RC F', 'RX 300', 'RX 330', 'RX 350', 'RX 350L', 'RX 400h', 'RX 450h', 'RX 450hL', 'RX 500h', 'RZ 450e', 'SC 300', 'SC 400', 'SC 430', 'TX 350', 'TX 500h', 'TX 550h+', 'UX 200', 'UX 250h', 'UX 300e'],
  'lincoln': ['Aviator', 'Blackwood', 'Continental', 'Corsair', 'LS', 'Mark LT', 'Mark VII', 'Mark VIII', 'MKC', 'MKS', 'MKT', 'MKX', 'MKZ', 'Nautilus', 'Navigator', 'Navigator L', 'Town Car', 'Zephyr'],
  'lotus': ['Elan', 'Elise', 'Esprit', 'Evora', 'Exige'],
  'lucid': ['Air'],
  'maserati': ['Biturbo', 'Coupe', 'Ghibli', 'GranSport', 'GranTurismo', 'Grecale', 'Levante', 'MC20', 'Quattroporte', 'Spyder'],
  'maybach': ['57', '62', 'GLS 600', 'S 580', 'S 680'],
  'mazda': ['2', '3', '3 Sport', '323', '5', '6', '626', '929', 'B-Series', 'CX-3', 'CX-30', 'CX-5', 'CX-50', 'CX-7', 'CX-9', 'CX-90', 'GLC', 'Miata MX-5', 'Millenia', 'MPV', 'MX-3', 'MX-5 Miata', 'MX-6', 'Navajo', 'Protege', 'Protege5', 'RX-7', 'RX-8', 'Tribute'],
  'mclaren': ['570S', '600LT', '650S', '675LT', '720S', '765LT', 'Artura', 'GT', 'MP4-12C', 'P1', 'Senna', 'Speedtail'],
  'mercedes-benz': ['190D', '190E', '260E', '300CE', '300D', '300E', '300SD', '300SDL', '300SE', '300SEL', '300SL', '300TD', '300TE', '350SD', '350SDL', '380SE', '380SEC', '380SEL', '380SL', '380SLC', '400E', '400SE', '400SEL', '420SEL', '500E', '500SEC', '500SEL', '500SL', '560SEC', '560SEL', '560SL', 'A-Class', 'AMG GT', 'AMG One', 'B-Class', 'C-Class', 'CL-Class', 'CLA-Class', 'CLK-Class', 'CLS-Class', 'E-Class', 'EQA', 'EQB', 'EQC', 'EQE', 'EQS', 'EQV', 'G-Class', 'GL-Class', 'GLA-Class', 'GLB-Class', 'GLC-Class', 'GLE-Class', 'GLK-Class', 'GLS-Class', 'M-Class', 'Metris', 'R-Class', 'S-Class', 'SL-Class', 'SLC-Class', 'SLK-Class', 'SLR McLaren', 'SLS AMG', 'Sprinter', 'V-Class', 'X-Class'],
  'mercury': ['Capri', 'Cougar', 'Grand Marquis', 'Lynx', 'Marauder', 'Mariner', 'Marquis', 'Milan', 'Montego', 'Monterey', 'Mountaineer', 'Mystique', 'Sable', 'Topaz', 'Tracer', 'Villager', 'Zephyr'],
  'mini': ['Clubman', 'Convertible', 'Cooper', 'Cooper Clubman', 'Cooper Convertible', 'Cooper Countryman', 'Cooper Coupe', 'Cooper Hardtop', 'Cooper Paceman', 'Cooper Roadster', 'Countryman', 'Coupe', 'Hardtop', 'Paceman', 'Roadster'],
  'mitsubishi': ['3000GT', 'Cordia', 'Diamante', 'Eclipse', 'Eclipse Cross', 'Endeavor', 'Expo', 'Galant', 'i-MiEV', 'Lancer', 'Lancer Evolution', 'Mighty Max', 'Mirage', 'Mirage G4', 'Montero', 'Montero Sport', 'Outlander', 'Outlander PHEV', 'Outlander Sport', 'Precis', 'Raider', 'RVR', 'Sigma', 'Space Wagon', 'Starion', 'Tredia', 'Van'],
  'nissan': ['200SX', '240SX', '300ZX', '350Z', '370Z', 'Altima', 'Armada', 'Ariya', 'Axxess', 'Cube', 'Frontier', 'GT-R', 'Juke', 'Kicks', 'Leaf', 'Maxima', 'Murano', 'Murano CrossCabriolet', 'NV1500', 'NV200', 'NV2500', 'NV3500', 'NX', 'Pathfinder', 'Pickup', 'Pulsar', 'Quest', 'Rogue', 'Rogue Select', 'Rogue Sport', 'Sentra', 'Stanza', 'Titan', 'Titan XD', 'Van', 'Versa', 'Versa Note', 'Xterra', 'Z'],
  'oldsmobile': ['88', '98', 'Achieva', 'Alero', 'Aurora', 'Bravada', 'Custom Cruiser', 'Cutlass', 'Cutlass Calais', 'Cutlass Ciera', 'Cutlass Supreme', 'Firenza', 'Intrigue', 'LSS', 'Regency', 'Silhouette', 'Toronado'],
  'panoz': ['Esperante'],
  'plymouth': ['Acclaim', 'Arrow', 'Breeze', 'Caravelle', 'Colt', 'Conquest', 'Duster', 'Gran Fury', 'Grand Voyager', 'Horizon', 'Laser', 'Neon', 'Prowler', 'Reliant', 'Sapporo', 'Scamp', 'Sundance', 'Turismo', 'Voyager'],
  'polestar': ['1', '2', '3', '4', '5'],
  'pontiac': ['1000', '6000', 'Aztek', 'Bonneville', 'Catalina', 'Fiero', 'Firebird', 'G3', 'G4', 'G5', 'G6', 'G8', 'Grand Am', 'Grand Prix', 'GTO', 'J2000', 'LeMans', 'Montana', 'Parisienne', 'Phoenix', 'Pursuit', 'Safari', 'Solstice', 'Sunbird', 'Sunburst', 'Sunfire', 'T1000', 'Torrent', 'Trans Sport', 'Vibe', 'Wave'],
  'porsche': ['718 Boxster', '718 Cayman', '718 Spyder', '911', '924', '928', '944', '968', 'Boxster', 'Carrera GT', 'Cayenne', 'Cayman', 'Macan', 'Panamera', 'Taycan'],
  'ram': ['1500', '1500 Classic', '1500 TRX', '2500', '3500', 'C/V', 'C/V Tradesman', 'Dakota', 'ProMaster 1500', 'ProMaster 2500', 'ProMaster 3500', 'ProMaster City', 'ProMaster Rapid'],
  'rivian': ['R1S', 'R1T'],
  'rolls-royce': ['Camargue', 'Corniche', 'Cullinan', 'Dawn', 'Ghost', 'Park Ward', 'Phantom', 'Silver Dawn', 'Silver Seraph', 'Silver Spirit', 'Silver Spur', 'Spectre', 'Wraith'],
  'saab': ['9-2X', '9-3', '9-3X', '9-4X', '9-5', '9-7X', '900', '9000'],
  'saturn': ['Astra', 'Aura', 'Ion', 'L-Series', 'LW-Series', 'Outlook', 'Relay', 'S-Series', 'Sky', 'SW-Series', 'Vue'],
  'scion': ['FR-S', 'iA', 'iM', 'iQ', 'tC', 'xA', 'xB', 'xD'],
  'smart': ['fortwo', 'fortwo electric drive'],
  'sterling': ['825', '827'],
  'subaru': ['Ascent', 'B9 Tribeca', 'Baja', 'BRAT', 'BRZ', 'Crosstrek', 'Forester', 'Impreza', 'Impreza WRX', 'Impreza WRX STI', 'Justy', 'Legacy', 'Loyale', 'Outback', 'Solterra', 'SVX', 'Tribeca', 'WRX', 'WRX STI', 'XT', 'XV Crosstrek'],
  'suzuki': ['Aerio', 'Equator', 'Esteem', 'Forenza', 'Grand Vitara', 'Kizashi', 'Reno', 'Samurai', 'Sidekick', 'Swift', 'SX4', 'Verona', 'Vitara', 'X-90', 'XL-7'],
  'tesla': ['Cybertruck', 'Model 3', 'Model S', 'Model X', 'Model Y', 'Roadster'],
  'toyota': ['4Runner', '86', 'Avalon', 'bZ4X', 'C-HR', 'Camry', 'Camry Hybrid', 'Camry Solara', 'Celica', 'Corolla', 'Corolla Cross', 'Corolla Hatchback', 'Corolla Hybrid', 'Corolla iM', 'Corona', 'Cressida', 'Crown', 'Echo', 'FJ Cruiser', 'GR Supra', 'GR86', 'Grand Highlander', 'Highlander', 'Land Cruiser', 'Matrix', 'Mirai', 'MR2', 'MR2 Spyder', 'Paseo', 'Pickup', 'Previa', 'Prius', 'Prius AWD-e', 'Prius c', 'Prius Plug-in', 'Prius Prime', 'Prius v', 'RAV4', 'RAV4 EV', 'RAV4 Hybrid', 'RAV4 Prime', 'Sequoia', 'Sienna', 'Soarer', 'Solara', 'Starlet', 'Supra', 'T100', 'Tacoma', 'Tercel', 'Tundra', 'Van', 'Venza', 'Yaris', 'Yaris iA', 'Yaris Sedan'],
  'volkswagen': ['Arteon', 'Atlas', 'Atlas Cross Sport', 'Beetle', 'Cabrio', 'Cabriolet', 'CC', 'Corrado', 'Dasher', 'Eos', 'EuroVan', 'Fox', 'GLI', 'Golf', 'Golf Alltrack', 'Golf GTI', 'Golf R', 'Golf SportWagen', 'GTI', 'ID.4', 'ID. Buzz', 'Jetta', 'Jetta GLI', 'Jetta SportWagen', 'Jetta Wagon', 'New Beetle', 'Passat', 'Phaeton', 'Pickup', 'Quantum', 'Rabbit', 'Routan', 'Scirocco', 'Taos', 'Tiguan', 'Tiguan Limited', 'Touareg', 'Vanagon'],
  'volvo': ['240', '260', '740', '760', '780', '850', '940', '960', 'C30', 'C40 Recharge', 'C70', 'Coupe', 'S40', 'S60', 'S60 Cross Country', 'S60 Recharge', 'S70', 'S80', 'S90', 'S90 Recharge', 'V40', 'V50', 'V60', 'V60 Cross Country', 'V60 Recharge', 'V70', 'V90', 'V90 Cross Country', 'V90 Recharge', 'XC40', 'XC40 Recharge', 'XC60', 'XC60 Recharge', 'XC70', 'XC90', 'XC90 Recharge'],
  'workhorse': ['FASLANE', 'P42', 'W15', 'W42', 'W62']
};

  const toCanon = raw => {
    const lc = raw.toLowerCase().trim();
    return makeAlias[lc] || (makeCanonical[lc] ? lc : null);
  };
  const modelsLower = Object.fromEntries(Object.entries(knownModels)
                       .map(([mk, arr]) => [mk, arr.map(m=>m.toLowerCase())]));

  const $year   = document.getElementById('year');
const $make   = document.getElementById('make');
const $model  = document.getElementById('model');
const $btn    = document.getElementById('partsFinderButton');
const makePH  = $make.options[0].text;
const modelPH = $model.options[0].text;

// Spinner overlay helpers
function showSelectSpinner(selectEl, text) {
  const wrap = selectEl.closest('.pf-select-wrap');
  if (!wrap) return;
  let overlay = wrap.querySelector('.pf-spinner-overlay');
  if (overlay) overlay.remove();
  overlay = document.createElement('div');
  overlay.className = 'pf-spinner-overlay';
  overlay.innerHTML = `
    <span class="pf-spinner-icon"></span>
    <span class="pf-spinner-text">${text||'Loading…'}</span>
  `;
  wrap.appendChild(overlay);
}
function hideSelectSpinner(selectEl) {
  const wrap = selectEl.closest('.pf-select-wrap');
  if (!wrap) return;
  const overlay = wrap.querySelector('.pf-spinner-overlay');
  if (overlay) overlay.remove();
}

function fetchTagJSONProgressive(tagPath, onPage, onDone) {
  let page = 1, acc = [], hasMore = true;
  function next() {
    const url = `/collections/all/${tagPath}?view=pf-json&page=${page}`;
    fetch(url, { credentials: 'same-origin' })
      .then(r => r.text())
      .then(txt => {
        let arr;
        try { arr = JSON.parse(txt); }
        catch (e) { throw new Error("Not JSON: " + url); }
        acc = acc.concat(arr);
        onPage(arr, acc);
        if (arr.length < 50) { hasMore = false; onDone(acc); }
        else { page++; next(); }
      })
      .catch(e => { onDone(acc, e); });
  }
  next();
}

$year.addEventListener('change', () => {
  const y = $year.value;
  resetSelect($make, makePH);
  resetSelect($model, modelPH);
  $btn.disabled = true;
  showSelectSpinner($make, "Loading makes…");

  const makeSet = new Set();
  fetchTagJSONProgressive(encodeURIComponent(y),
    (arr, acc) => {
      arr.forEach(p => p.tags.forEach(t => {
        const canon = toCanon(t);
        if (canon) makeSet.add(canon);
      }));
      populate($make, makeSet, mk => makeCanonical[mk]);
    },
    (acc, err) => {
      hideSelectSpinner($make);
      if (err) console.error('Year fetch failed', err);
    }
  );
});

$make.addEventListener('change', () => {
  const y  = $year.value;
  const mk = $make.value;
  resetSelect($model, modelPH);
  $btn.disabled = true;
  showSelectSpinner($model, "Loading models…");

  const tagPath = `${encodeURIComponent(y)}+${encodeURIComponent(mk)}`;
  const modSet = new Set();
  fetchTagJSONProgressive(tagPath,
    (arr, acc) => {
      arr.forEach(p => p.tags.forEach(t => {
        if (modelsLower[mk]?.includes(t.toLowerCase())) modSet.add(t);
      }));
      populate($model, modSet);
    },
    (acc, err) => {
      hideSelectSpinner($model);
      if (err) console.error('Make fetch failed', err);
    }
  );
});

  $model.addEventListener('change', () => {
    $btn.disabled = !$model.value;
  });

  $btn.addEventListener('click', (e) => {
  e.preventDefault();
  const year  = ($year.value || '').trim();
  const makeD = ($make.selectedIndex > -1 ? $make.options[$make.selectedIndex].text : $make.value || '').trim();
  const model = ($model.value || '').trim();
  if (!(year && makeD && model)) return;

  // Force query-style tag filtering
  const constraint = [year, makeD, model].map(s => encodeURIComponent(s)).join('+');
  location.assign('/collections/all?constraint=' + constraint);
});


  function resetSelect(sel, ph) {
    sel.innerHTML = `<option value="" disabled selected>${ph}</option>`;
    sel.disabled  = true;
  }
  function populate(sel, set, labelFn=x=>x) {
    const existing = new Set();
    for (let i=1; i<sel.options.length; ++i) {
      existing.add(sel.options[i].value);
    }
    // Only add new ones
    Array.from(set).sort().forEach(v => {
      if (!existing.has(v)) {
        const opt = document.createElement('option');
        opt.value = v;
        opt.text  = labelFn(v);
        sel.appendChild(opt);
      }
    });
    if (set.size) sel.disabled = false;
  }
})();